module.exports = "images/blo-de-kim.jpg";